import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { DAY_CONTROLS_ROLE } from '@core/models/day-controls';
import { AuthService } from '@core/services/auth';
import { DAY_CONTROLS_ENABLED } from '@core/services/day-controls';

/**
 * Matches the Day Controls page only where this environment enables it, and only for a token carrying the role;
 * anyone else lands on the dashboard. A signed-out visitor matches, so the auth guard can send them to sign in and
 * bring them back to the link.
 */
export const dayControlsGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const dashboard = router.createUrlTree(['/dashboard']);

  if (!inject(DAY_CONTROLS_ENABLED)) {
    return dashboard;
  }
  await auth.awaitReady();
  if (!auth.isAuthenticated()) {
    return true;
  }
  return auth.roles().includes(DAY_CONTROLS_ROLE) ? true : dashboard;
};
